import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { Notifications, NotificationsPaged, NotificationType, PayloadItem } from 'src/app/models/notificacao';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-notificacao-list',
  templateUrl: './notificacao-list.component.html',
  styleUrls: ['./notificacao-list.component.css']
})
export class NotificacaoListComponent implements OnInit {
  showButton: boolean = false;
  textButton: string;

  constructor(
    private notificacaoService: NotificacaoService,
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  public currentUser: Auth;
  public notificacoes: Notifications[];
  public notificacaoSelecionada: Notifications;
  public notificacaoTipo = 0;
  public titles: NotificationType;
  public open = false

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.notificacaoService.getTypesNotification('C')
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.titles = response.result;
      }
    })
    this.carregarNotificacoes(1);
  }

  carregarNotificacoes(page){
    this.open = false;
    this.currentPage = page;
    this.notificacaoService.getListNotification(this.currentUser.token.pessoaId,(page-1),+this.showItem,this.notificacaoTipo)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.notificacoes = response.result.notificacoes;
        this.totalItems = response.result.total;
        console.log(this.notificacoes)
      }
    });
  }

  tipoNotificacao(tipo){    
    this.notificacaoTipo = tipo;
    this.carregarNotificacoes(1);
  }

  selecionarNotificacao(item){
    this.open = true;

    this.notificacaoService.getDetalNotification(item.id)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.notificacaoSelecionada = response.result;
        this.createButton(this.notificacaoSelecionada);
      }
    });

    /*if(item.unread){
      this.notificacaoService.setReadNotification(item.id)
      .subscribe(response => {
        if (response.status === ApiError.Sucesso) {
        }
      });
    }*/
  }    

  createButton(item: Notifications){
    if(item.notificationType == 14){
      this.showButton = true;
      this.textButton = "Ver detalhes da recarga";
    } else {
      this.showButton = false;
    }
  }

  clickButton(item: Notifications){
    if(item.notificationType == 14){
      this.router.navigate([`portal/minhasrecargas/details/`+ this.getPayloadValue(item.notificationPayload.items,'compraId')]);
    }
  }
  
  showItemChanged(event) {
    this.showItem = event;
    this.carregarNotificacoes(1);
  }

  getPayloadValue(item: PayloadItem[], key: string) {
    return item.find(x => x.payloadKey == key)? item.find(x => x.payloadKey == key).payloadValue : '';
  }

  toPurchaseDetails(item){
    this.router.navigate([`portal/minhasrecargas/details/${item}`]);
  }
}
